export enum USER_ROLE {
    ADMIN = 'admin',
    USER = 'user',
    UNSET = 'unset',
}
